"use client"
import {Swiper, SwiperSlide} from 'swiper/react';
import {Skeleton} from '@mui/material';
import {Row} from "@/core/general/row.component";
import {VideoGardiGenreDetailModel} from "@/core/model/tmk.model";
import {FreeMode} from "swiper/modules";
import {MenuBuilderWidgetModel} from "@/core/model/main.model";
import {Column} from "@/core/general/column.component";
import {useRouter} from "next/navigation";
import {VIDEO_LIST_PATH} from "@/core/CONSTANTS";
import Link from 'next/link';

interface Props {
    genreList: VideoGardiGenreDetailModel[]
    widget: MenuBuilderWidgetModel;
    hasTitle: boolean;
}

export function VideoGardiGenreSwiperComponent(props: Props) {

    return (
        <Column className={"py-2"}>
            {props.genreList?.length > 0 ? (
                <Row className="flex-nowrap overflow-scroll hideScrollBar">
                    <Swiper slidesPerView={'auto'} spaceBetween={10} freeMode={true} className={"!px-8"} modules={[FreeMode]}>
                        {props.genreList?.map((item, index) => (
                            <SwiperSlide style={{width: 'auto'}} key={index} virtualIndex={index}>
                                <Link href={VIDEO_LIST_PATH+`${item.id}/${encodeURIComponent(item?.name?.fa??"")}`}>
                                    <Row className={"py-2 my-2 px-4 cursor-pointer bgCard shadowLg rounded-md w-auto"}>
                                        <img alt={""} src={item.icon??"/placeholder.svg"} className={"!h-6 !w-6 rounded-sm"}/>
                                        <div className="w-auto ps-2 mText" key={index}>
                                            {item.name.fa}
                                        </div>
                                    </Row>
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Row>
            ) : (
                <Row className="flex-nowrap overflow-scroll hideScrollBar">
                    {[...Array(5)].map((i, index) => (
                        <div key={index} className="w-auto p-2">
                            <Skeleton className="card card-box rounded-1 h-12" variant="rectangular"/>
                        </div>
                    ))}
                </Row>
            )}
        </Column>
    );
};
